import { render } from "./AppPdfViewer.vue?vue&type=template&id=bbdf76da&scoped=true&ts=true"
import script from "./AppPdfViewer.vue?vue&type=script&lang=ts"
export * from "./AppPdfViewer.vue?vue&type=script&lang=ts"

import "./AppPdfViewer.vue?vue&type=style&index=0&id=bbdf76da&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbdf76da"]])

export default __exports__